// * GET =====================================
export const EXPORT_SCHEDULE_GET_GET_OBJECT_EXPORT_SCHEDULES = `/export_schedule/get_object_export_schedules`;
// * PATCH ===================================

// * POST ====================================
export const EXPORT_SCHEDULE_POST_TOGGLE_STATUS = (exportScheduleId: string) =>
  `/export_schedule/${exportScheduleId}/toggle_status`;

// * DELETE ==================================
export const EXPORT_SCHEDULE_DELETE_DELETE = (exportScheduleId: string) =>
  `/export_schedule/${exportScheduleId}/delete`;

// * PUT =====================================
export const EXPORT_SCHEDULE_PUT = `/export_schedule`;
